module.exports = __webpack_public_path__ + "img/avatar6.39956833.jpg";